function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

// add custom event on checkout
// document.querySelector('body').addEventListener('click', function(e) {
//   if (e.target.matches('button[name=checkout]')){
//     e.preventDefault();
//     fetch(window.Shopify.routes.root + 'cart.js', {
//       method: 'GET',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//     })
//     .then(cartresponse => {
//       return cartresponse.json();
//     })
//     .then(cartresponse => {
//       const ItemSKU = cartresponse.items.map((item) => {
//         return item.sku != null ? item.sku: '';
//       }).filter((ele) => ele != '');
//       const ItemSKUStr = ItemSKU.join(',');
//       clevertap.event.push("Continue to Checkout", {
//         "SKU": ItemSKUStr,
//         "Price": parseFloat(cartresponse.total_price / 100),
//         "Date": new Date()
//       });
//       setTimeout(() => {
//         window.location.href = '/checkout';
//       }, 500);
//     })
//     .catch((error) => {
//       console.error('Error:', error);
//       setTimeout(() => {
//         window.location.href = '/checkout';
//       }, 500);
//     });
//   }
// })
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.querySelector('.menu-drawer__submenu') != null) {
    summary.setAttribute('aria-controls', summary.querySelector('.menu-drawer__submenu').getAttribute('id'));
  } else if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }


  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

document.querySelectorAll('[data-video-play-wrapper] svg').forEach((btn) => {
  if(btn.closest('.video-section-with-text') != null){
    const video  = btn.closest('.video-section-with-text').querySelector('video');
    btn.addEventListener('click', function () {

      if (video.paused || video.ended) {
        video.play();
      } else {
        video.pause();
      }
      // console.log('video.paused',video.paused,video);
    })
    video.addEventListener("playing", function () {
      btn.style.opacity = 0;
    });
    video.addEventListener("pause", function () {
      btn.style.opacity = 1;
    });
  }
});

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    if($(event.target).closest('.cart-item').length > 0){
      $(event.target).attr('disabled',true);
    }
    if(event.target.name === 'plus'){
      function showToast(target) {
        let existingToast = document.querySelector('.toast');
        if (existingToast) {
            existingToast.remove();
        }
    
        const toast = document.createElement('div');
        toast.className = 'toast';
        toast.innerHTML = `<span class="icon_toast">
          <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeInherit" viewBox="0 0 22 22" aria-hidden="true" width="22" height="22"><path fill="#b71c1c" d="M10.083 13.75h1.833v1.833h-1.833zm0-7.333h1.833v5.5h-1.833zm.907-4.583C5.931 1.833 1.833 5.94 1.833 11s4.097 9.167 9.158 9.167c5.069 0 9.176-4.107 9.176-9.167s-4.107-9.167-9.176-9.167m.009 16.5c-4.052 0-7.333-3.282-7.333-7.333S6.949 3.667 11 3.667 18.333 6.949 18.333 11 15.051 18.333 11 18.333"/></svg>
        </span>
        <span class="message">
        <h3>Maximum quantity reached.</h3>
        <p>For bulk orders email us at: <a href="mailto:b2b.global@plixlife.com">b2b.global@plixlife.com</a></p>
        </span>
        <span class="closethis_pop" onclick="this.closest('.toast').remove()">        
          <svg width="12" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.292893 14.6147C-0.0976311 15.0052 -0.0976311 15.6384 0.292893 16.0289C0.683417 16.4194 1.31658 16.4194 1.70711 16.0289L0.292893 14.6147ZM1.70711 16.0289L15.7071 2.02888L14.2929 0.614671L0.292893 14.6147L1.70711 16.0289Z" fill="#7C211C"/>
            <path d="M1.70711 0.61467C1.31658 0.224146 0.683417 0.224146 0.292893 0.61467C-0.0976314 1.00519 -0.0976315 1.63836 0.292893 2.02888L1.70711 0.61467ZM0.292893 2.02888L14.2929 16.0289L15.7071 14.6147L1.70711 0.61467L0.292893 2.02888Z" fill="#7C211C"/>
          </svg>
        </span>`;
    
        $(target).append(toast);
    
        // setTimeout(() => {
        //     toast.style.opacity = '0';
        //     setTimeout(() => toast.remove(), 500);
        // }, 3000);
      }
      if($(event.target).closest('.cart-item').length > 0){
        var cartqty = $(event.target).closest('.cart-item').find('.quantity__input').attr('data-cart-quantity');
        var maxqty = parseInt($(event.target).closest('.cart-item').attr('data-maxqty'));
        if(cartqty >= maxqty){
          showToast($(event.target).closest('.cart-item').find('.cart-item__details'));
          $(event.target).removeAttr('disabled');
          return;
        }else{
          event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
          if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);  
        }  
      }else{
        var cartqty = $(event.target).closest('[data-atc-container]').find('.quantity__input[name="quantity"]').attr('data-cart-quantity');
        var maxqty = parseInt($(event.target).closest('[data-atc-container]').find('variant-radios input[type="radio"]:checked').attr('data-maxqty'));
        var totaladdingqty = parseInt(cartqty) + parseInt(this.input.value);
        if(totaladdingqty >= maxqty){
          showToast($(event.target).closest('[data-atc-container]').find('.product-form__quantity__wrapper'));
          $(event.target).removeAttr('disabled');
          return;
        }else{
          event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
          if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);  
        }
      }
      
    }else{
      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);  
    }
    
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);      
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);      
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.closeMenuBtn = this.querySelector('.icon-close');
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
    this.querySelector('.icon-close').addEventListener('click', function () {
      document.querySelector('summary.header__icon').click()
    })
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );

    if (window.innerWidth > 990) {
      // this.querySelectorAll('summary.menu-drawer__menu-item').forEach((summary) =>
      //   summary.addEventListener('mouseover', this.onSummaryClick.bind(this))
      // );
      // this.querySelectorAll('summary.menu-drawer__menu-item').forEach((summary) =>
      //   summary.addEventListener('mouseleave', this.onCloseButtonClick.bind(this))
      // );
      this.querySelectorAll('summary.menu-drawer__menu-item a, a.menu-drawer__menu-item').forEach((summary) =>
        summary.addEventListener('mouseover', this.openDrawer.bind(this))
      );
    }
  }
  openDrawer(event) {
    if (event.currentTarget.closest('summary') == null) {
      // console.log('hello null');
      document.querySelectorAll('details.details-menu-drawer').forEach(function (det) {
        det.removeAttribute('open', '');
        det.classList.remove('menu-opening', 'expanded');
      })
      return;
    }
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.closest('details');
    if(detailsElement.querySelectorAll('.product-link').length > 0){
      document.querySelectorAll('details.details-menu-drawer').forEach(function (det) {
        det.setAttribute('open', '');
        det.classList.remove('menu-opening', 'expanded');
      })
      // document.querySelector('details.details-menu-drawer').
      detailsElement.classList.add('menu-opening', 'expanded');
    } else{
      document.querySelectorAll('details.details-menu-drawer').forEach(function (det) {
        det.removeAttribute('open', '');
        det.classList.remove('menu-opening', 'expanded');
      })
    }

  }
  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    // hide sticky bar on menu open
    if(document.querySelector('.sticky-atc-section') != null && window.innerWidth < 990){ 
      document.querySelector('.sticky-atc-section').style.zIndex = 'unset';
    }
    // console.log('summaryElement', summaryElement)
    if (summaryElement.classList.contains('menu-drawer__menu-item') && window.innerWidth < 900) {
      return;
    }

    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const nextEle = summaryElement.nextElementSibling != null ? summaryElement.nextElementSibling : summaryElement.querySelector('.menu-drawer__submenu');

    if (nextEle == null) {
      this.onCloseButtonClick.bind(this);
    }
    function addTrapFocus() {
      trapFocus(nextEle, detailsElement.querySelector('button'));
      nextEle.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        detailsElement.setAttribute('open', '');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : nextEle.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);

    if(document.querySelector('.sticky-atc-section') != null && window.innerWidth < 990){ 
      document.querySelector('.sticky-atc-section').style.zIndex = '4';
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    event.stopPropagation();

    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    // detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    // removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }


  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this;
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.scrollbar = this.querySelector('.swiper-scrollbar');
    this.prevnav = this.querySelector('.swiper-button-prev');
    this.nextnav = this.querySelector('.swiper-button-next');
    this.showNav = this.querySelector('[data-prevNextArrows]') != null ? true : false;
    this.freeMode = this.slider.dataset.freemode ? true : false;
    this.slidesDesktop = this.slider.dataset.slidesDesktop;
    this.slidesTablet = this.slider.dataset.slidesTablet;
    this.slidesMobile = this.slider.dataset.slidesMobile;
    this.desktopSpacing = this.slider.dataset.desktopSpacing;
    this.mobileSpacing = this.slider.dataset.mobileSpacing;
    this.tabletSpacing = this.slider.dataset.tabletSpacing;
    this.activeIndexChange =  this.querySelector('[data-showActiveChangeFunction]') != null ? true : false;

    // console.log('rhis.slider',this.slider,this.slidesDesktop,this.slidesTablet,this.slidesMobile,this.freeMode,this.slider.dataset.freemode);

    this.navObj = false;
    if (this.showNav) {
      this.navObj = {
        nextEl: this.nextnav,
        prevEl: this.prevnav
      }
    }
    if (!this.slider) return;

    this.initSlider();
  }


  initSlider() {
    var sliderswiper = new Swiper(this.slider, {
      // observer : true,
      slidesPerView: this.slidesMobile,
      freeMode: this.freeMode,
      grabCursor: true,
      preloadImages: true,
      centerSlides: false,
      spaceBetween: this.mobileSpacing,
      watchSlidesProgress: true,
      shortSwipes: false,
      loop: false,
      keyboard: true,
      breakpoints: {
        // when window width is >= 600
        600: {
          slidesPerView: this.slidesTablet,
          spaceBetween: this.tabletSpacing,
        },
        // when window width is >= 900
        950: {
          slidesPerView: this.slidesDesktop,
          spaceBetween: this.desktopSpacing
        }
      },
      scrollbar: {
        el: this.scrollbar,
        hide: false
      },
      navigation: this.navObj,
    })
    // console.log('hello slider',sliderswiper);
  }
  

}

customElements.define('slider-component', SliderComponent);

class MobileSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this;
    this.sliderItems = this.querySelectorAll('.product__media-item');
    this.thumbSlider = this.querySelector('.gallery-thumbs');
    this.main = this.querySelector('.gallery-top');
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.scrollbar = this.querySelector('.swiper-scrollbar');
    this.prevnav = this.querySelector('.swiper-button-prev');
    this.nextnav = this.querySelector('.swiper-button-next');
    this.showNav = this.querySelector('[data-prevNextArrows]') != null ? true : false;
    this.freeMode = this.slider.dataset.freemode ? true : false;
    this.slidesDesktop = this.slider.dataset.slidesDesktop;
    this.slidesTablet = this.slider.dataset.slidesTablet;
    this.slidesMobile = this.slider.dataset.slidesMobile;
    this.desktopSpacing = this.slider.dataset.desktopSpacing;
    this.mobileSpacing = this.slider.dataset.mobileSpacing;
    this.tabletSpacing = this.slider.dataset.tabletSpacing;

    // console.log('rhis.slider',this.slider,this.slidesDesktop,this.slidesTablet,this.slidesMobile,this.freeMode,this.slider.dataset.freemode);

    this.navObj = false;
    if (this.showNav) {
      this.navObj = {
        nextEl: this.nextnav,
        prevEl: this.prevnav
      }
    }
    if (!this.slider) return;
    this.initSlider();
  }
  initSlider() {

    var galleryThumbs = new Swiper(this.thumbSlider, {
      centeredSlides: true,
      centeredSlidesBounds: true,
      slidesPerView: 5,
      spaceBetween: 10,
      freeMode: false,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      loop:false,
      keyboard: true,
      breakpoints: {
        // when window width is >= 900
        901: {
          spaceBetween: 16,
        }
      },
    });

    var galleryMain = new Swiper(this.main, {
      freeMode: this.freeMode,
      grabCursor: false,
      preloadImages: true,
      slidesPerView: this.slidesDesktop, 
      spaceBetween: 10,
      centerSlides: true,
      watchSlidesProgress: false,
      shortSwipes: true,
      longSwipes: false,
      loop: false,
      thumbs: { 
        swiper: galleryThumbs
      },
      navigation: this.navObj
    });
  }
}
customElements.define('product-slider-component', MobileSliderComponent);

class SlideshowComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this;
    this.autoplay = this.querySelector('.swiper-wrapper').dataset.autoplay;
    this.sliderSpeed = this.querySelector('.swiper-wrapper').dataset.speed * 1000;
    let autoplayObj = false;
    this.showThumb = this.querySelector('.swiper-wrapper').dataset.showThumb;
    this.pagination = this.querySelector('.swiper-wrapper').dataset.pagination;
    this.paginationType = this.querySelector('.swiper-wrapper').dataset.paginationType;
    if (this.showThumb == 'true') {
      this.thumbSlider = this.parentElement.querySelector('.swiper-nav');
    }
    // this.paused = this.slider.swiper != null ? !this.slider.swiper.autoplay.running : false;
    let paginationObj = null;
    let thumbsObj = null;


    if (this.pagination == 'true') {

      if (this.paginationType == 'numbers') {
        paginationObj = {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
          }
        }
      } else if (this.paginationType == 'fraction') {
        paginationObj = {
          el: ".swiper-pagination",
          type: 'fraction'
        }
      } else {
        paginationObj = {
          el: ".swiper-pagination",
          clickable: true,
        }
      }
    }

    if (this.autoplay == 'true') {
      autoplayObj = {
        delay: this.sliderSpeed,
        disableOnInteraction: true,
      }
    }

    if (this.showThumb == 'true') {
      var swiper = new Swiper(this.thumbSlider, {
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true
      });
      thumbsObj = {
        swiper: swiper
      }
      var swiper2 = new Swiper(this, {
        thumbs: thumbsObj,
        autoplay: autoplayObj,
        pagination: paginationObj != null ? paginationObj : false,
        shortSwipes: true,
        longSwipes: false,
        keyboard: true
      })
    } else {
      var swiper2 = new Swiper(this, {
        autoplay: autoplayObj,
        pagination: paginationObj != null ? paginationObj : false,
        freeMode: false,
        shortSwipes: true,
        longSwipes: false,
        keyboard: true
      })
      // console.log('swiper2', swiper2)
    }

  }


  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked && this.desktopLayout.matches) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.querySelector('.announcement-bar-slider').contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    this.slider.swiper.autoplay.start();
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    this.slider.swiper.autoplay.stop();
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  slideToSlide(ind) {
    this.slider.swiper.slideTo(ind);
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    if(document.querySelector('[data-variant-info]')!= null) this.variantJSON = JSON.parse(document.querySelector('[data-variant-info]').innerHTML);
    // this.addEventListener('change', this.onVariantChange);
    
    this.inputs = this.querySelectorAll('input'); 
    this.productImagesJSON = document.querySelector('[data-media-json]') != null ? JSON.parse(document.querySelector('[data-media-json]').innerHTML) : null;
    console.log('this.inputs',this.inputs);
    var _this = this;
    this.inputs.forEach((input) =>{
      input.addEventListener('change', function(){
        _this.onVariantChange(input);
      })
    })
  }

  onVariantChange(input) {
    this.changePricing(input);
    this.updatePackMedia(input);
    
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateSubscriptionPricing();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      // this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  changePricing(input){
    // console.log('this',this,this.closest('product-info'));
    let swtch = input;
    // console.log('swtahc',e.currentTarget);
    var free_gift_id = $(swtch).attr("variant_free_gift_id") 

    let subBox = this.closest('product-info').querySelector('[data-product-subscription-box]');
    let atcBtnPrice = this.closest('product-info').querySelector('[data-atc-price]');
    let atcBtncompPrice = this.closest('product-info').querySelector('[data-compare-price]');
    let stickyatcBtnPrice = document.querySelector('[data-sticky-atc] [data-atc-price]');    
    let stickyatcBtncompPrice = document.querySelector('[data-sticky-atc] [data-compare-price]');    
    let freqMsgBox;
    if (subBox != null)  freqMsgBox = subBox.querySelector('[data-freq-msg-container]');
    
    // console.log('atcBtnPrice',e.currentTarget.closest('[data-grid-prd-form]'),subBox.querySelector('.onetime-option [data-atc-prc]'));
    
    if(subBox != null){
        // change prices
        // console.log('swtch.dataset.comPrice',swtch,swtch.dataset.comPrice);
      // if(subBox.querySelector('[data-cur-comp-price]') != null) subBox.querySelector('[data-cur-comp-price]').innerHTML = swtch.dataset.comPrice;
      if(subBox.querySelectorAll('[data-cur-comp-price]') != null) subBox.querySelectorAll('[data-cur-comp-price]').forEach((ele) => {ele.innerHTML = swtch.dataset.comPrice;})
      if(subBox.querySelectorAll('[data-cur-price]') != null) subBox.querySelectorAll('[data-cur-price]').forEach((ele) => {ele.innerHTML = swtch.dataset.price;})
      if(subBox.querySelector('[data-cur-sub-price]') != null) subBox.querySelector('[data-cur-sub-price]').innerHTML = swtch.dataset.subPrice;

      if(subBox.querySelector('#radio-onetime[data-atc-prc]') != null) {
        if(document.querySelector('[data-product-custom-diet-box] input') != null){ // check if custom diet plan exists
          subBox.querySelector('#radio-onetime[data-atc-prc]').dataset.atcPrc =  document.querySelector('[data-product-custom-diet-box] input').checked ? swtch.dataset.atcBtnPrice : swtch.dataset.price;
        } else{
          subBox.querySelector('#radio-onetime[data-atc-prc]').dataset.atcPrc =  swtch.dataset.price;
        }
      }
      if(subBox.querySelector('#radio-subscription[data-atc-prc]') != null) {
        // subBox.querySelector('#radio-subscription[data-atc-prc]').dataset.atcPrc = swtch.dataset.subAtcPrice;
        if(document.querySelector('[data-product-custom-diet-box] input') != null){
           subBox.querySelector('#radio-subscription[data-atc-prc]').dataset.atcPrc =  document.querySelector('[data-product-custom-diet-box] input').checked ? swtch.dataset.subAtcPrice : swtch.dataset.subPrice;
        } else{
           subBox.querySelector('#radio-subscription[data-atc-prc]').dataset.atcPrc =  swtch.dataset.subPrice;
        }
        if(swtch.dataset.sellingPlan != undefined && swtch.dataset.sellingPlan != '' ){
          // change selling plan
          subBox.querySelector('#radio-subscription[data-atc-prc]').value = swtch.dataset.sellingPlan;
        } 
        
      }

      // change percentages
      if(subBox.querySelector('[data-cur-comp-discount]') != null) subBox.querySelector('[data-cur-comp-discount]').innerHTML = '-'+swtch.dataset.compDiscount + '%';
      if(subBox.querySelector('[data-cur-sub-discount]') != null) subBox.querySelector('[data-cur-sub-discount]').innerHTML = '-'+swtch.dataset.subDiscount + '%';

      if(freqMsgBox != null && swtch.dataset.freqMsgFirstPart != '' && swtch.dataset.freqMsgLastPart != '') {
        let freqFirstPart = swtch.dataset.freqMsgFirstPart
        let freqLastPart = swtch.dataset.freqMsgLastPart
        freqMsgBox.innerHTML = `<span class="light">${freqFirstPart}</span> ${freqLastPart}` 
      }
    } else{
      if(document.querySelector('[data-product-custom-diet-box] input') != null){ // check if custom diet plan exists
        swtch.dataset.atcPrc =  document.querySelector('[data-product-custom-diet-box] input').checked ? swtch.dataset.atcBtnPrice : swtch.dataset.price;
        
        if(swtch.dataset.comPrice != ''){
         swtch.dataset.atccomPrice =  document.querySelector('[data-product-custom-diet-box] input').checked ? swtch.dataset.atcBtnCompprice : swtch.dataset.comPrice; 
        }else{
         swtch.dataset.atccomPrice = '';
        }        
      } 
    }

    if(atcBtnPrice != null || stickyatcBtnPrice != null) {
      // console.log('atcBtnPrice',atcBtnPrice);
      if(subBox != null){ // subscription exists        
        if(atcBtnPrice != null) atcBtnPrice.innerHTML = subBox.querySelector('input:checked').dataset.atcPrc;
        if(stickyatcBtnPrice != null) stickyatcBtnPrice.innerHTML = subBox.querySelector('input:checked').dataset.atcPrc;
      } else{  
        console.log(swtch)
        if(atcBtnPrice != null)  atcBtnPrice.innerHTML = swtch.dataset.atcPrc;
        if(atcBtncompPrice != null)  atcBtncompPrice.innerHTML = swtch.dataset.atccomPrice;
        if(stickyatcBtnPrice != null) stickyatcBtnPrice.innerHTML = swtch.dataset.atcPrc;
        if(stickyatcBtncompPrice != null) stickyatcBtncompPrice.innerHTML = swtch.dataset.atccomPrice;
      }
    }
    console.log('hiijijij',free_gift_id)
    $('#free_gift_product_data').attr('free_gift_id',free_gift_id)
  }
  updatePackMedia(input){
    if($('.variant_base_images[data-varianttitle="'+input.value.toLowerCase()+'"]').length > 0){
      $('.variant_base_images').hide();
      $('.variant_base_images[data-varianttitle="'+input.value.toLowerCase()+'"]').show(); 
      $('.variant_base_images[data-varianttitle="'+input.value.toLowerCase()+'"] .product_media_main_slider').slick('refresh');
      $('.variant_base_images[data-varianttitle="'+input.value.toLowerCase()+'"] .media_thumbnail_items').slick('refresh');
    }    
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          // console.log('option',option,this.options[index],index);
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
 
  updateSubscriptionPricing(){
    if(this.closest('product-info').querySelector('[data-product-subscription-box]') == null || this.variantJSON == undefined) return;
    
    let subBox = this.closest('product-info').querySelector('[data-product-subscription-box]');
    let curvarPricing = this.variantJSON.product_variants.filter((variant)=> this.currentVariant.id == variant.id);
    // console.log('curvarPricing',curvarPricing);
    if(subBox != null){
        // change prices 
      // if(subBox.querySelector('[data-cur-comp-price]') != null) subBox.querySelector('[data-cur-comp-price]').innerHTML = curvarPricing[0].compare_at_price;
      if(subBox.querySelectorAll('[data-cur-comp-price]') != null) subBox.querySelectorAll('[data-cur-comp-price]').forEach((ele) => {ele.innerHTML = curvarPricing[0].compare_at_price;})
      if(subBox.querySelectorAll('[data-cur-price]') != null) subBox.querySelectorAll('[data-cur-price]').forEach((ele) => {ele.innerHTML = curvarPricing[0].price;})
      if(subBox.querySelector('#radio-onetime[data-atc-prc]') != null) subBox.querySelector('#radio-onetime[data-atc-prc]').dataset.atcPrc = curvarPricing[0].price;
      if(subBox.querySelector('[data-cur-sub-price]') != null) subBox.querySelector('[data-cur-sub-price]').innerHTML = curvarPricing[0].subscription_price + curvarPricing[0].frequency;
      if(subBox.querySelector('#radio-subscription[data-atc-prc]') != null) {
        subBox.querySelector('#radio-subscription[data-atc-prc]').dataset.atcPrc = curvarPricing[0].subscription_price + curvarPricing[0].frequency;
        if(curvarPricing[0].selling_plan != undefined && curvarPricing[0].selling_plan != '' ){
          // change selling plan
          subBox.querySelector('#radio-subscription[data-atc-prc]').value = curvarPricing[0].selling_plan;
        } 
      }

      // change percentages
      if(subBox.querySelector('[data-cur-comp-discount]') != null) subBox.querySelector('[data-cur-comp-discount]').innerHTML = curvarPricing[0].prdDis;
      if(subBox.querySelector('[data-cur-sub-discount]') != null) subBox.querySelector('[data-cur-sub-discount]').innerHTML = curvarPricing[0].subscriptionDiscount;
 
    }

  }   
  updateMedia() { 
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;
        

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] .product-form__buttons__text > span');
    const addButtonPrice = productForm.querySelector('[name="add"] .product-form__buttons__text span[data-atc-price]');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      // console.log('this.variantJSON',this.variantJSON);
      // if(document.querySelector('[data-product-subscription-box]') != null){ // if subscription box exists
      //   addButtonPrice.textContent = document.querySelector('[data-product-subscription-box] input:checked').dataset.atcPrc;
      // } else{
      //   addButtonPrice.textContent = Shopify.formatMoney(this.currentVariant.price, '${{amount_no_decimals}}');
      // }
      
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] .product-form__buttons__text > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  // getVariantData() {
  //   this.variantData = this.variantData || this.querySelector('[type="application/json"][data-variant-json]') != null ? JSON.parse(this.querySelector('[type="application/json"][data-variant-json]').textContent) : null;
  //   // console.log('this.variantData',this.variantData);
  //   return this.variantData;
  // }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
    // console.log('this.options',this.options,fieldsets,this.querySelectorAll('fieldset'));
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class TabifySection extends HTMLElement {
  constructor() {
    super();
    this.tabButtons = this.querySelectorAll('[role="tab"]');
    this.tabPanels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    this.tabButtons.forEach((button) => button.addEventListener('click', this.handleTabClick));
  }
  handleTabClick(event) {
    let _this = this.closest('tabify-section');
    _this.tabPanels.forEach((panel) => {
      //panel.hidden = true;
      panel.classList.remove('show');
    });
    _this.tabButtons.forEach((tab) => {
      tab.setAttribute('aria-selected', false);
    });
    event.currentTarget.setAttribute('aria-selected', true);
    const { id } = event.currentTarget;
    const tabPanel = _this.tabPanels.find((panel) => {
      if (panel.getAttribute('aria-labelledby') === id) {
        return true;
      }
    });
    tabPanel.classList.add('show');
  }
}

customElements.define('tabify-section', TabifySection);


function loadAppData() {
  if (document.querySelectorAll('[data-app-section]').length) {
    document.querySelectorAll('[data-app-section]').forEach(function (doc) {
      // add insta username
      if (doc.querySelector('#insta-feed') != null) {
        let instaId = doc.dataset.instaId;
        let instaLink = doc.dataset.instaLink;
        let customTitle = setInterval(function () {
          if (doc.querySelector('#insta-feed h2') != null) {
            doc.querySelector('#insta-feed h2').insertAdjacentHTML('beforeend', '<a target="_blank" href="' + instaLink + '" class="linkL">' + instaId + '</a>')
            clearInterval(customTitle);
          }
        })
      }
    })
  }
}
if (document.querySelector('[data-newsletter-signup]') != null) {
  document.querySelector('[data-newsletter-signup]').addEventListener('click', function () {
    // console.log('submti form');
    let userEmail = this.parentElement.querySelector('[data-email]').value;
    let userPhone = this.parentElement.querySelector('[data-mobile-number]').value;
    let successEle = this.parentElement.querySelector('[data-success-message]');
    // console.log('userEmail', userEmail, 'userPhone', userPhone);
    let isFormValid = validateForm(this.parentElement);
    // console.log('isFormValid', isFormValid);
    if (isFormValid) {
      // console.log('valid');

      this.setAttribute('aria-disabled', true);
      this.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      successEle.classList.add('hidden');

      // first create user
      clevertap.onUserLogin.push({
        "Site": {
          "Identity": userEmail.toString(),              // String or number
          "Email": userEmail.toString(),   // Email address of the user
          "Phone": userPhone
        }
      });
      // Event to track the users
      setTimeout(() => {
        clevertap.event.push("Subscribed Newsletter", {
          "Email": userEmail.toString()
        });
        this.setAttribute('aria-disabled', false);
        this.classList.remove('loading');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        this.parentElement.querySelector('[data-email]').value = '';
        this.parentElement.querySelector('[data-mobile-number]').value = '';
        successEle.classList.remove('hidden');
      }, 2000);
    }

  })
}

if (document.querySelector('[data-mobile-number]') != null) {
  document.querySelector('[data-mobile-number]').addEventListener('focus', function () {
    if (this.value == '') {
      this.value = '+971';
    }
  })
}

function validateForm(form){
  document.querySelectorAll('[data-error-text]').forEach(function(error){
    // console.log('hello clear',error);
    error.classList.add('opaque');
    if(error.parentElement.querySelector('input,textarea') != null ) error.parentElement.querySelector('input,textarea').classList.remove('error-input');

  })
  let reqFields = form.querySelectorAll('input[aria-required="true"],textarea[aria-required="true"]');
  let fields = form.querySelectorAll('input');
  let pattern = ''
  var flag = 1;
  // console.log('reqFields',reqFields);
  reqFields.forEach(function (field) {
    // console.log('fiels', field.type, field);
    if (field.value == '') {
      displayError(field, 'This field is required')

      flag = 0;

    }

  })
  // console.log('flag',flag);
  fields.forEach(function (field) {
    // console.log('field.required',field.required);
    if (field.type == 'email' && field.value != '' && !field.required) {
      // console.log('if email');
      pattern = /^[^ ]+@[^ ]+\.[a-z]{2,3}$/;
      if (!field.value.match(pattern)) {
        displayError(field, 'Please Enter Valid Email Address');
        flag = 0;
      }

    } else if (field.type == 'tel' && field.value != '') {
      // console.log('elseif tel');
      pattern = /^\+[1-9]{1}[0-9]{3,14}$/;
      if (!field.value.match(pattern)) {
        displayError(field, '"Please Enter Valid Phone Number');
        flag = 0;
      }
    }
  })
  return flag ? true : false;
}
function displayError(field, text) {
  field.classList.add('error-input');
  field.parentElement.querySelector('[data-error-text]').setAttribute('aria-invalid', true);
  field.parentElement.querySelector('[data-error-text]').setAttribute('aria-describedby', text);
  field.parentElement.querySelector('[data-error-text]').innerText = text;
  field.parentElement.querySelector('[data-error-text]').classList.remove('opaque');
  field.parentElement.querySelector('[data-error-text]').focus();
}

function matchHeight(parent) {
  let getEleHeight = [];
  let largestDesc = 0;
  parent.querySelectorAll('[data-match-height-ele]').forEach((ele) => {
    let eleHeight = ele.offsetHeight;
    getEleHeight.push(eleHeight);
    for (let index = 0; index < getEleHeight.length; index++) {
      const element = getEleHeight[index];
      if (element > largestDesc) {
        largestDesc = element;
      }
    }
  });
  parent.querySelectorAll('[data-match-height-ele]').forEach((ele) => {
    ele.style.minHeight = largestDesc + 'px';
  });
}
window.addEventListener("load", (event) => {
  console.log("page is fully loaded");
  loadAppData();
  // if (document.querySelectorAll('[data-match-height-container]').length) {
  //   document.querySelectorAll('[data-match-height-container]').forEach(function (container) {
  //     matchHeight(container);
  //   })
  // }
});

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

if(document.querySelector('#redirection_banner .close_icon')){
  document.querySelector('#redirection_banner .close_icon').addEventListener('click',()=>{
    document.querySelector('#redirection_banner').remove();
    window.history.replaceState(null, '', window.location.href.split("?")[0]);
  }); 
} 

$(document).ready(function(){
  
  $('.product_media_main_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    dots: false,
    draggable: false,
    focusOnSelect: true,
    asNavFor: '.media_thumbnail_items',
    infinite: false
  });
  $('.media_thumbnail_items').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.product_media_main_slider',
    dots: false,
    arrows: true,
    focusOnSelect: true,
    infinite: false
  });
});

$('body').on('click','.product-swatches .swatch', function(){
  var _this = this;
  _this.classList.add('loading');
  const productHandle = this.getAttribute('data-handle');
  const productContainer = document.getElementById('MainContent');

  console.log(productContainer);
  // Show a loading indicator (optional)

  // Step 1: Fetch new product data using Shopify Product JSON API
  fetch(`/products/${productHandle}`)
    .then(response => response.text())
    .then(responseHTML => {

      const parser = new DOMParser();
      const doc = parser.parseFromString(responseHTML, 'text/html');
  
      // Extract the product content you want to append
      const newProductContent = doc.querySelector('#MainContent');
      
      if (newProductContent) {
        // Append the extracted content to the container
        productContainer.innerHTML = newProductContent.innerHTML;
      } else {
        console.error('Error: Product content not found.');
      }          

      // Step 3: Update the URL without reloading the page
      history.pushState({}, '', `/products/${productHandle}`);

      // Step 4: Reinitialize Focal Theme Scripts
      if (window.Shopify && Shopify.theme && Shopify.theme.sections) {
        Shopify.theme.sections.load(productContainer);
      }
      $('.product_media_main_slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: false,
        dots: false,
        draggable: false,
        focusOnSelect: true,
        asNavFor: '.media_thumbnail_items',
        infinite: false
      });
      $('.media_thumbnail_items').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.product_media_main_slider',
        dots: false,
        arrows: true,
        focusOnSelect: true,
        infinite: false
      });
      initializeScrollAnimationTrigger();
      // Remove the loading indicator
      _this.classList.remove('loading');
    })
    .catch(error => {
      console.error('Error loading new product:', error)
      _this.classList.remove('loading');
    });
});
